import { useFormContext } from 'react-hook-form'
import SelectTagInputWithCheckboxes from '@/components/SelectTagInputWithCheckboxes'
import type { EditPostFormData } from '../types'

interface FormTopicsFieldProps {
  items: { id: string; name: string }[]
  loading: boolean
}

export function FormTopicsField({ items, loading }: FormTopicsFieldProps) {
  const { watch, setValue } = useFormContext<EditPostFormData>()
  const value = watch('topics') || []
  return (
    <div className="space-y-2">
      <label className="text-sm">Tópicos (opcional):</label>
      <SelectTagInputWithCheckboxes
        value={value}
        onChange={(v) => setValue('topics', v, { shouldDirty: true })}
        placeholder="Pesquisar"
        items={items}
        loading={loading}
      />
    </div>
  )
}
